import { useState, useEffect } from "react";
import { useApiCall } from "./useApiCall";

export const useCustomer = () => {
  const [customer, setCustomer] = useState();
  const [customerStatus, setCustomerStatus] = useState("idle");
  const [customerError, setCustomerError] = useState();
  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();

  const fetchCustomer = (customerId) => {
    if (customerId) {
      setCustomerStatus("pending");

      const requestOptions = {
        url: `/users/${customerId}`,
      };

      executeApiCall(requestOptions);

      setCustomerError();
    }
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse?.data?.data) {
          const { user } = apiCallResponse.data.data;

          setCustomer(user);
          setCustomerStatus("ready");
        }

        if (apiCallResponse?.data?.error) {
          const { error } = apiCallResponse.data;

          setCustomerError(error.userMessage);
          setCustomerStatus("ready");
        }
        break;
      case "error":
        setCustomerStatus("ready");
        break;
    }
  }, [apiCallStatus, apiCallResponse]);

  return {
    fetchCustomer,
    customer,
    customerStatus,
    customerError,
  };
};
